import { Stack, Typography, Button, Box } from '@mui/material';
import { useClient } from '../../../../context/ClientContext';
import { ClientOptionButton } from '../../common/ClientOptionButton';
import StepsHeading from '../../common/StepsHeading';

export default function Ethnicity({ userData, setUserData, onNext, onBack }) {
    const { theme } = useClient();
    const options = ['Asian', 'Black', 'White', 'Latino', 'Other'];

    // const selectEthnicity = (ethnicity) => {
    //     setUserData({ ...userData, ethnicity });
    //     onNext();
    // };


    const handleOptionSelect = (field, value) => {
        setUserData({ ...userData, [field]: value });
        // Call onNext directly after selection to move to the next step
        onNext();
    };

    return (
        <Stack spacing={2}>

            <StepsHeading title={"What is your ethnicity?"} />
            <Stack
                sx={{
                    width: '100%',
                    alignItems: 'center',
                }}
            >
                {[
                    { label: "American Indian or Alaska Native", value: 1 },
                    { label: "Asian", value: 2 },
                    { label: "Black or African American", value: 3 },
                    { label: "Hispanic or Latino", value: 4 },
                    { label: "Native Hawaiian or Pacific Islander", value: 5 },
                    { label: "White", value: 6 },
                    { label: "Mixed", value: 7 },
                    { label: "Prefer not to say", value: 8 }
                ].map((option, index) => (
                    <ClientOptionButton
                        key={index}
                        optionSelectSingleValue={userData.ethnicity}  // Pass the current selected value
                        value={option.value}  // Pass value to compare with userData
                        option={option.label}
                        onClick={() => handleOptionSelect("ethnicity", option.value)}
                        optionBtnSx={{
                            // margin: "0px 0px",
                            marginBottom: "8px",
                            height: {
                                xs: '36px',
                                sm: '48px',
                                md: '48px',
                                lg: '50px'
                            },
                            // boxShadow: "rgba(0, 0, 0, 0.15) 0px 1px",
                            // marginBottom: '0px',
                            gap: 0
                        }}
                    />
                ))}
            </Stack>
            {/* <Button onClick={onBack}>Back</Button> */}
        </Stack>
    );
}
